import { BaseColumnType } from '../types/types'

export const clicksColumnModel: BaseColumnType = {
  field: 'clicks',
  width: 60,
  filterable: false,
  valueGetter: (params) => params.value
}
